import moment from 'moment'
import create, { SetState, StateCreator, StoreApi } from 'zustand'

interface ICalenderViewStore {
    // isProfileView:boolean,
    // setProfileView: (x:any) => void
    collapsedProfile:boolean,
    setCollapsedProfile: (x:any) => void,
    viewForCalender:boolean,
    setViewForCalender: (x:any) => void,
    isDrillDownViewSelected: boolean,
    setIsDrillDownViewSelected:(x:any) => void,
    isDayDrillDownView: boolean,
    setIsDayDrillDownView:(x:any) => void,
    isMonthDrillDownView: boolean,
    setIsMonthDrillDownView:(x:any) => void,
    appointmentPatientSelected: any,
    setAppointmentPatientSelected:(x:any) => void,
    selectedDateCalender:any,
    setSelectedDateCalender:(x:any) => void,
    isKPIDataLoaded:boolean,
    setisKPIDataLoaded:(x:any) => void,
    selectedPatientProfile:any,
    setSelectedPatientProfile:(x:any) => void,
    masterDayData:any,
    setMasterDayData:(x:any) => void,
    masterMonthData:any,
    setMasterMonthData:(x:any) => void,
    monthViewAppointmentData:any,
    setMonthViewAppointmentData:(x:any) => void,
    isProfileView:boolean,
    setIsProfileView:(x:any) => void,
    isFilterMonthApplied:boolean,
    setIsFilterMonthApplied:(x:any) => void,

    monthFilter:any,
    setMonthFilter:(x:any) => void,
    // dependenceFilterKey:any,
    // setDependenceFilterKey:(x:any) => void,
    // dependenceFilterObject:any,
    // setDependenceFilterObject:(x:any) => void,

    isMonthChange:boolean,
    setIsMonthChange:(x:any) => void,
    officeId:any,
    setOfficeId:(x:any) => void,
    officeName:any,
    setOfficeName:(x:any) => void,
    dayFilter:any,
    setDayFilter:(x:any) => void,
    isFilterDayApplied:boolean,
    setIsFilterDayApplied:(x:any) => void,
    applyFilterFlag:boolean,
    setApplyFilterFlag:(x:any) => void,
    balanceOfMonthFlag:boolean,
    setBalanceOfMonthFlag:(x:boolean) => void,

    dependenceFilterKey:any,
    setDependenceFilterKey:(x:any) => void,
    dependenceFilterObject:any,
    setDependenceFilterObject:(x:any) => void,
    selectedActiveMonthFilters:any,
    setSelectedActiveMonthFilters:(x:any) => void,
    selectedActiveDayFilters:any,
    setSelectedActiveDayFilters:(x:any) => void,

    clearStore: () => void
}

let  store: StateCreator<ICalenderViewStore, [], [], ICalenderViewStore> | StoreApi<ICalenderViewStore> = (set: SetState<ICalenderViewStore>) => ({
    
    collapsedProfile: false,
    setCollapsedProfile: (x) => {
      set(state => ({ collapsedProfile: x }))
    },

    viewForCalender:false,
    setViewForCalender: (x) => {
        set(state => ({ viewForCalender: x }))
    },

    isDrillDownViewSelected:false,
    setIsDrillDownViewSelected: (x) => {
      set(state => ({ isDrillDownViewSelected: x }))
    },

    isDayDrillDownView:false,
    setIsDayDrillDownView:(x) => {
      set(state => ({ isDayDrillDownView: x }))
    },

    isMonthDrillDownView:false,
    setIsMonthDrillDownView:(x) => {
      set(state => ({ isMonthDrillDownView: x }))
    },

    appointmentPatientSelected:undefined,
    setAppointmentPatientSelected:(x) => {
      set(state => ({ appointmentPatientSelected: x }))
    },

    selectedDateCalender:moment(),
    setSelectedDateCalender:(x) => {
      set(state => ({ selectedDateCalender: x }))
    },

    isKPIDataLoaded:false,
    setisKPIDataLoaded:(x) => {
      set(state => ({ isKPIDataLoaded: x }))
    },

    selectedPatientProfile:undefined,
    setSelectedPatientProfile:(x) => {
      set(state => ({ selectedPatientProfile: x }))
    },

    masterDayData:undefined,
    setMasterDayData:(x) => {
      set(state => ({ masterDayData: x }))
    },

    masterMonthData:undefined,
    setMasterMonthData:(x) => {
      set(state => ({ masterMonthData: x }))
    },

    monthViewAppointmentData:undefined,
    setMonthViewAppointmentData:(x) => {
      set(state => ({ monthViewAppointmentData: x }))
    },

    isProfileView:true,
    setIsProfileView:(x) => {
      set(state => ({ isProfileView: x }))
    },

    officeId:`${process.env.REACT_APP_DENTAL_DEFAULT_OFFICE_ID}`,
    setOfficeId:(x) => {
      set(state => ({ officeId: x }))
    },

    officeName:`${process.env.REACT_APP_DENTAL_DEFAULT_OFFICE_NAME}`,
    setOfficeName:(x) => {
      set(state => ({ officeName: x }))
    },

    dayFilter:{provider_type:[],provider_name:[]},
    setDayFilter:(x) => {
      set(state => ({ dayFilter: x }))
    },

    isFilterDayApplied:false,
    setIsFilterDayApplied:(x) => {
      set(state => ({ isFilterDayApplied: x }))
    },

    applyFilterFlag:false,
    setApplyFilterFlag:(x) => {
      set(state => ({ applyFilterFlag: x }))
    },

    // monthFilter:{ vintage:[], state:[], brand:[], office_active_status:[],office_name:[], provider_type:[], provider_name:[] },
    monthFilter:{ vintage:[], state:[], brand:[], office_active_status:[],office_name:[], provider_type:[], provider_name:[] },
      setMonthFilter:(x) => {
      set(state => ({ monthFilter: x }))
    },

    isFilterMonthApplied:false,
    setIsFilterMonthApplied:(x) => {
      set(state => ({ isFilterMonthApplied: x }))
    },

    isMonthChange:false,
    setIsMonthChange:(x) => {
      set(state => ({ isMonthChange: x }))
    },

    balanceOfMonthFlag:false,
    setBalanceOfMonthFlag:(x) => {
      set(state => ({ balanceOfMonthFlag: x }))
    },
    
    dependenceFilterKey:"",
    setDependenceFilterKey:(x) => {
      set(state => ({ dependenceFilterKey: x }))
    },

    dependenceFilterObject:[],
    setDependenceFilterObject:(x) => {
      set(state => ({ dependenceFilterObject: x }))
    },

    selectedActiveMonthFilters:[],
    setSelectedActiveMonthFilters:(x) => {
      set(state => ({ selectedActiveMonthFilters: x }))
    },

    selectedActiveDayFilters:["office_name"],
    setSelectedActiveDayFilters:(x) => {
      set(state => ({ selectedActiveDayFilters: x }))
    },

    clearStore: () => {
      set(() => ({collapsedProfile:  false}));
      set(() => ({viewForCalender :  false}));
      set(() => ({isDrillDownViewSelected :  false}));
      set(() => ({isDayDrillDownView :  false}));
      set(() => ({isMonthDrillDownView :  false}));
      set(() => ({appointmentPatientSelected :  undefined}));
      set(() => ({selectedDateCalender:moment()}));
      set(() => ({isKPIDataLoaded:false}));
      set(() => ({selectedPatientProfile:undefined}));
      set(() => ({masterDayData:undefined}));
      set(() => ({masterMonthData:undefined}));
      set(() => ({monthViewAppointmentData:undefined}));
      set(() => ({isProfileView:true}));
      set(() => ({officeId:`${process.env.REACT_APP_DENTAL_DEFAULT_OFFICE_ID}`}));
      set(() => ({officeName:`${process.env.REACT_APP_DENTAL_DEFAULT_OFFICE_NAME}`}));
      set(() => ({dayFilter:{provider_type:[],provider_name:[]}}));
      set(() => ({isFilterDayApplied:false}));
      set(() => ({applyFilterFlag:false}));
      set(() => ({monthFilter:{ vintage:[], state:[], brand:[], office_active_status:[],office_name:[], provider_type:[], provider_name:[] }}));
      set(() => ({isFilterMonthApplied:false}));
      set(() => ({isMonthChange:false}));
      set(() => ({balanceOfMonthFlag:false}));
      set(() => ({dependenceFilterKey:""}));
      set(() => ({dependenceFilterObject:[]}));
      set(() => ({dependenceFilterObject:[]}));
      set(() => ({selectedActiveMonthFilters:[]}));
      set(() => ({selectedActiveDayFilters:["office_name"]}));
    }
  })
  
  
  export const useCalenderViewStore  = create(store)

